import React from 'react'
import styled, { css } from 'styled-components'
import { NavLink } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'

import MEDIA from 'styles/media'
import LINKS from './config/links'
import { MobileNavContext } from '../../contexts/mobile-nav'

const LinksWrapper = styled.div`
  flex-grow: 1;
  margin-left: 46px;

  ${MEDIA.mobile} {
    display: flex;
    flex-direction: column;
    flex: none;
    margin-left: 0;
  }
`

const linkStyle = css`
  display: inline-flex;
  height: ${({ theme }) => theme.navHeight};
  align-items: center;
  margin-bottom: 1px;
  font-size: 14px;
  font-weight: 700;
  text-decoration: none;
  color: ${({ theme }) => theme.primaryFaded};
  border-bottom: 2px solid transparent;

  &:not(:last-of-type) {
    margin-right: 40px;
  }

  &.active {
    color: ${({ theme }) => theme.warning};
    border-bottom-color: ${({ theme }) => theme.warning};
  }

  ${MEDIA.mobile} {
    height: auto;
    margin: 0 0 20px 0;
    font-size: 24px;
    font-weight: 500;

    &.active {
      position: relative;
      font-weight: 700;
      border: none;

      &::before {
        position: absolute;
        top: 4px;
        left: -12px;
        display: block;
        width: 2px;
        height: 20px;
        content: '';
        background: ${({ theme }) => theme.warning};
      }
    }
  }
`

const StyledNavLink = styled(NavLink)`
  ${linkStyle};
`

const StyledLink = styled.a`
  ${linkStyle}
`

const Nav = () => (
  <MobileNavContext.Consumer>
    {({ onClick }) => (
      <LinksWrapper>
        {LINKS.map(({ to, i18n }) => (
          <StyledNavLink key={to} to={to} onClick={onClick}>
            <FormattedMessage {...i18n} />
          </StyledNavLink>
        ))}
        <StyledLink href='https://help.gradoo.com/de' target='_blank'>
          <FormattedMessage id='Nav.help' />
        </StyledLink>
      </LinksWrapper>
    )}
  </MobileNavContext.Consumer>
)

export default Nav



// WEBPACK FOOTER //
// ./src/layouts/DefaultLayout/components/NavBar/components/Nav/index.js